"use client"

import React from "react";

const ProgressBar = ({ current, total, colour }: {
    current: number;
    total: number;
    colour?: string;
}) => {
  const progress = (current / total) * 100;

  return (
    <div className="w-full mb-2">
      <div className="w-full bg-gray-200 rounded-full h-2.5">
        <div
          className={`h-2.5 rounded-full transition-all duration-300 ${
            progress < 50 ? "bg-orange-500" : "bg-primary"
          }`}
          style={{ width: `${progress}%`, ...(colour ? { backgroundColor: colour } : {}) }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;
